import axios from "axios";
import moment from 'moment';

export const continueSession = async (tokenParam?: string) => {
  const token = tokenParam || (await localStorage.getItem("jwtToken"));

  if (!token) {
    console.warn("No hay token, cerrando sesión");
    logoutapp();
    return false;
  }

  const now = moment();
  const lastActivity = await localStorage.getItem("LastActivity");
  const lastActivityMoment = moment(lastActivity);
  const minutesSinceLastActivity = moment.duration(now.diff(lastActivityMoment)).minutes();

  try {
    const { data, status } = await axios.post(
      `${process.env.REACT_APP_APPLICATION_LOGIN_BACK}/api/verify`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
      }
    );

    if (status === 200) {
      const expMoment = moment(data.expDateTime);
      const minutesToExpire = moment.duration(expMoment.diff(now)).minutes();

      await localStorage.setItem("sUntil", data.expDateTime);
      await localStorage.setItem("validation", "true");
      await localStorage.setItem("MinToClose", `${minutesToExpire} - ${minutesSinceLastActivity}`);

      if (data.data.IdUsuario) {
        await localStorage.setItem("IdCentral", data.data.IdUsuario);
        await getUserDetails(data.data.IdUsuario);
        await getAppDetails(localStorage.getItem("IdApp")!);
      }

      if (minutesToExpire <= -1) {
        console.warn("Logout por expiración");
        logoutapp();
        return false;
      }

      if (minutesToExpire <= 16) {
        renewSession();
      }

      return true;
    }
  } catch (error: any) {
    console.error("Error al verificar sesión:", error);

    if (error.response?.status && error.response.status !== 200) {
      console.warn("Logout por error del servidor");
      logoutapp();
    }

    return false;
  }
};


export const getUserDetails = async (idCentral: string) => {
  const token = await localStorage.getItem("jwtToken");
  const idApp = await localStorage.getItem("IdApp");
  return axios
    .post(
      process.env.REACT_APP_APPLICATION_LOGIN_BACK + "/api/userapp-detail",
      {
        IdUsuario: idCentral,
        IdApp: idApp,
      },
      {
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
      }
    )
    .then(async (r) => {
      if (r.status === 200) {
        await localStorage.setItem("IdUsuario", r.data.data.Id);
        await localStorage.setItem("NombreUsuario", r.data.data.Nombre.split(" ")[0] + " " + r.data.data.ApellidoPaterno);
        await localStorage.setItem("Telefono", r.data.data.Telefono);
        await localStorage.setItem("CorreoElectronico", r.data.data.CorreoElectronico);
        await localStorage.setItem("Entidad", r.data.data.Entidad);
        await localStorage.setItem("Puesto", r.data.data.Puesto);
        await localStorage.setItem("IdEntidad", r.data?.data?.IdEntidad);
        var rolesUser = { "Nombre": "Usuario", "Descripcion": "Usuario" };
        await localStorage.setItem("Roles", r.data.roles.length > 0 ? JSON.stringify(r.data.roles[0]) : JSON.stringify(rolesUser));
        var menuUser: Array<any> = [];
        await localStorage.setItem("userMenu", r.data.menus.length > 0 ? JSON.stringify(r.data.menus[0]) : JSON.stringify(menuUser));
        await localStorage.setItem("Departamento", r.data.data.Entidad || "SD");
        return true;
      }
    })
    .catch(async (error) => {
      if (error.response?.status) {
        console.warn("getUserDetails warn");
        await localStorage.clear();
        logoutapp();
      }
    });
};

export const getAppDetails = async (idApp: string) => {
  const token = await localStorage.getItem("jwtToken");
  return axios
    .post(process.env.REACT_APP_APPLICATION_LOGIN_BACK + "/api/app-detail",
      {
        IdApp: idApp,
      },
      {
        headers: {
          "Content-Type": "application/json",
          authorization: token || ""
        },
      })
    .then(async (r) => {
      if (r.status === 200) {
        await localStorage.setItem("AppName", r.data.data.Nombre);
        return true;
      }
    })
    .catch((error) => {
      if (error.response?.status) {
        logoutapp();
      }
    });
};

const renewSession = async () => {
  const refreshToken = await localStorage.getItem("refreshToken");
  const idApp = await localStorage.getItem("IdApp");
  axios.post(process.env.REACT_APP_APPLICATION_LOGIN_BACK + "/api/refresh-token",
    {
      refreshToken: refreshToken,
      IdApp: idApp
    },
    {
      headers: { "Content-Type": "application/json", },
    }).then(async (r) => {
      if (r.data.token) {
        await localStorage.setItem("jwtToken", r.data.token);
      }
    }).catch((err) => {
      logoutapp();
    });
};

export const logoutapp = () => {
  localStorage.clear();
  const timeId = setTimeout(() => {
    window.location.href = process.env.REACT_APP_APPLICATION_LOGIN!;
  }, 987)
  return () => {
    clearTimeout(timeId)
  }
};

export const validateSession = async (): Promise<boolean> => {
  const lastActivity = await localStorage.getItem("LastActivity");

  if (lastActivity) {
    const minutesSinceLast = moment().diff(moment(lastActivity), 'minutes');

    if (minutesSinceLast < 4) {
      return true;
    }
  }

  const response = await continueSession();
  if (response) {
    await localStorage.setItem("LastActivity", moment().format("YYYY-MM-DDTHH:mm:ss"));
  }

  return true;
};